// NPM
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from "recoil";
import { isNil, filter, uniqueId, map, isEmpty } from 'lodash';

//STYLING & COMPONENTS
import './newLayout.scss'
import { Carousel, Row, Col, Space, Menu, MenuProps } from 'antd';
import { DownOutlined, RightCircleTwoTone, LeftCircleTwoTone } from '@ant-design/icons'
import CategoryCard from './category-card/category-card'
import MobileSearch from '../layout/navigation-bar/search-bar/mobile-search'



// HELPERS
import { encode } from 'Helpers/enc';
import { generateCategoryTree } from 'Helpers/generate-categories-tree-v2';

//SERVICES AND RECOIL STATES
import { fetchCategoryList } from 'Services/inventory.services';
import { categoryAtom } from 'Recoil/inventory.atom';

interface BannerProps {
  key?: string;
  imageUrl: string;
  href: string;
}

export interface BannerListProps {
  banners: BannerProps[],
}

export const NewLayout: React.FC<BannerListProps> = ({ banners }) => {
  const history = useHistory();
  const { t } = useTranslation();

  //////////////////////Category section//////////////////////////////////////
  const [categoryState, setCategoryState] = useRecoilState<any>(categoryAtom);
  const [childOptions, setChildOptions] = useState<any>([]);
  const [mobileOptions, setMobileOptions] = useState<any>([]);
  const [category1, setCategory1] = useState<any>([]);
  const [visible, setVisible] = useState(false);
  //this is to limit the number of categories shown in the category bar
  let showAmtofCategories = '8'

  const onHoverIn = (category, level1) => {
    setVisible(true);
    if (level1==true){
      setChildOptions(category)
    } else if (level1==false){
      //this is for see more categories dropdown
      let seeMore = category.slice(showAmtofCategories)
      setChildOptions(seeMore)
    }
  }

  const onHoverOut = () => {
    setVisible(false)
  }

  const id = uniqueId('cascader--dropdown-');

  const handleFetchList = async () => {
    setCategoryState({
      ...categoryState,
      status: { ...categoryState.status, fetch: 'loading' }
    });

    const responseData = await fetchCategoryList({
      active: true,
      level: [1, 2, 3]
    });
    let temp: string[] =[];

    if (!isNil(responseData) && responseData.length) {
      let filteredCategories = filter(responseData, categoryObj => {
        return categoryObj.level <= 3;
      })
      let options = generateCategoryTree(filteredCategories)
      setCategory1(options)

      //for mobile view -> category card
      for (let i in responseData) {
        if (responseData[i].level === 1){
          temp.push(responseData[i]);
        }
      }
      setMobileOptions(temp)
    }
    else {
      setCategoryState({
        ...categoryState,
        status: { ...categoryState.status, fetch: 'error' }
      });
    }
  }

  const onCategoryClick = (selectedOptions: any) => {
    let id = selectedOptions?.value
    let name = selectedOptions?.label
    history.push('/products/catalog/list?name=' + encode(name) + '&category=' + encode(id))
  }

  const categoryChild = (category) => {
    return (
      <Menu
        onMouseOver={() => setVisible(true)}
        selectable={false}
        className="childCategory"
        style={{backgroundColor:'transparent',width:'33%',height:'inherit'}}
        >
        {map(category, (cate, i) => {
          if (cate.children === undefined) {
            return (
              <Menu.Item key={i} onClick={() => onCategoryClick(cate)}>{cate.label}</Menu.Item>
            )
          } else {
            return (
              <Menu.SubMenu popupClassName="childCategory"
                onTitleClick={() => onCategoryClick(cate)} key={i} title={cate.label} >
                {map(cate.children, (cat, k) => {
                  if(cat.children === undefined){
                    return (
                      <Menu.Item key={k} onClick={() => onCategoryClick(cat)}>{cat.label} </Menu.Item>
                    )
                  } else {
                    return (
                      <Menu.SubMenu popupClassName="childCategory"
                      onTitleClick={() => onCategoryClick(cat)} key={i} title={cat.label}>
                        {map(cat.children, (categ,l)=> {
                          return (
                            <Menu.Item key={l} onClick={() => onCategoryClick(categ)}>{categ.label} </Menu.Item>
                          )
                        })}
                      </Menu.SubMenu>
                    )
                  }
                })}
              </Menu.SubMenu>
            )
          }
        })}
      </Menu>
    )
  }

  useEffect(() => {
    handleFetchList();
  }, []);


  return (
    <div className="newLayout">
      <MobileSearch/>
      <div className="category-bar" onMouseLeave={() => onHoverOut()}>
        <Row align="middle" justify="space-around" className="row" >
          {map(category1, (category, index) => {
            if(index < showAmtofCategories){
              if (!isEmpty(category.children)) {
                return (
                  <Col  xs={0} sm={0} md={0} lg={12} flex="auto" className="each">
                    <Space direction="horizontal" onMouseEnter={() => onHoverIn(category.children, true)} size="middle" >
                      <p onClick={() => onCategoryClick(category)} >{category.label}</p>
                      <DownOutlined />
                    </Space>
                  </Col>
                )
              } else {
                return (
                  <Col xs={0} sm={0} md={0} lg={12} flex="auto" className="each" >
                    <Space direction="horizontal" size="large">
                      <p onClick={() => onCategoryClick(category)}> {category.label}</p>
                    </Space>
                  </Col>
                )
              }
            }
            }
          )}
          {category1.length>showAmtofCategories ? <Col xs={0} sm={0} md={0} lg={8} flex="auto" className="each">
          <Space  direction="horizontal" onMouseEnter={() => onHoverIn(category1, false)} size="middle" >
            <p>More Categories...</p>
            <DownOutlined />
          </Space>
          </Col>: <br/>}
        </Row>
      </div>

      <CategoryCard categories ={map(mobileOptions, (c, index) => {
                return {
                  _id: c._id,
                  name: c.name,
                  imageUrl: c?.image_data?.file_url || "",
                  href: `?category=${encode(c._id)}`,
                }
              })}/>
      <div className={visible ? 'dropdown-bar--shown' : 'dropdown-bar--hide'}
        onMouseEnter={()=>setVisible(true)}
        onMouseLeave={() => onHoverOut()}>
        {categoryChild(childOptions)}
      </div>
      {/* <div className="second-bar">
        <Row>
          <Col span={8}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src="/assets/images/shipping-discount.svg" alt="Shipping Discount" />
              <a href="">FREE Click & Collect on orders over RM20</a>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src="/assets/images/temp/shopping-bag.png" alt="Shop" />
              <a href="">FREE prescription delivery by DrEzy Marketplace</a>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src="/assets/images/temp/medical-symbol.png" alt="Shop" />
              <a href="">Talk to a doctor within 30 minutes</a>
            </div>
          </Col>
        </Row>
      </div> */}
      {/* <div className="third-bar">
        Available at checkout
      </div> */}
      <div className="banner-bar">
        <Carousel autoplay={true} arrows={true} prevArrow={<LeftCircleTwoTone twoToneColor="#442f84" />} nextArrow={<RightCircleTwoTone twoToneColor="#442f84" />} >
          {map(banners, (banner, k) => {
            return (
              <div
                className="banner" key={banner?.key ? banner?.key : k}>
                <a>
                  <img src={banner?.imageUrl} onClick={() => window.open(banner?.href)} alt="Banners" />
                </a>
              </div>
            )
          })}
        </Carousel>
      </div>
    </div>
  )
}
export default NewLayout;
